import { translate, useLocale } from "../localization";
import { NavLink } from "react-router-dom";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import "./SideNavigation.scss";
import { ReactComponent as Home } from "../images/Icon_home.svg";
import { ReactComponent as Students } from "../images/Icon_users.svg";
import { ReactComponent as User } from "../images/user_icon.svg";
import { ReactComponent as Guide } from "../images/icon_ai_guide.svg";
import { ReactComponent as Experience } from "../images/icon_experience.svg";
import { ReactComponent as Element } from "../images/icon_elements.svg";
import { ReactComponent as Environment } from "../images/icon_environments.svg";
import { ReactComponent as Collection } from "../images/icon_collections.svg";
import { ReactComponent as System } from "../images/icon_systems.svg";
import { Divider, Tooltip } from "@mui/material";
import PermissionGate from "./PermissionGate";
import { useAuth } from "../context/AuthContext";
import { canAccessSetupDownloads, isEducatorRole } from "../utility/accountRoles";

const SideNavigation = ({ isOpen, onClose }) => {
  useLocale();
  const { roleName } = useAuth();
  const getNavClassName = ({ isActive }) => (isActive ? translate("nav-link active") : "nav-link");
  const handleLinkClick = () => onClose?.();
  const shouldHideExperiencesLink = isEducatorRole(roleName);

  return (
    <>
      {isOpen && <div className="side-navigation__backdrop" onClick={onClose} />}
      <div className={`side-navigation ${isOpen ? "is-open" : ""}`}>
        <div className="top">
          <NavLink to="/" className={getNavClassName} end onClick={handleLinkClick}>
            <Home />{translate("Home")}</NavLink>
          <PermissionGate requiredPermission="viewAnalytics">
            <NavLink to="/dashboard" className={getNavClassName} onClick={handleLinkClick}>
              <QueryStatsRoundedIcon />{translate("Analytics")}</NavLink>
          </PermissionGate>
          <PermissionGate requiredPermission="viewAnalytics">
            <NavLink to="/sessions" className={getNavClassName} onClick={handleLinkClick}>
              <Students />{translate("Student sessions")}</NavLink>
          </PermissionGate>
          <div className="side-navigation__divider-wrap">
            <Divider variant="fullWidth" />
          </div>
          {!shouldHideExperiencesLink && (
            <PermissionGate requiredPermission="crudExperiences">
              <NavLink to="/experiences" className={getNavClassName} onClick={handleLinkClick}>
                <Experience />{translate("Experiences")}</NavLink>
            </PermissionGate>
          )}
          <PermissionGate
            requiredPermission="crudGuides"
            fallback={
              <Tooltip
                title={translate("Custom guide creation is available with a paid Classroom plan or Site license.")}
                describeChild
                placement="right"
                arrow
                enterTouchDelay={0}
                classes={{ popper: "side-navigation__tooltip" }}
              >
                <span className="nav-link nav-link--disabled" role="link" aria-disabled="true" tabIndex={0}>
                  <Guide />{translate("Guides ")}<br />{translate("(BETA)")}</span>
              </Tooltip>
            }
          >
            <NavLink to="/guides" className={getNavClassName} onClick={handleLinkClick}>
              <Guide />{translate("Guides ")}<br />{translate("(BETA)")}</NavLink>
          </PermissionGate>
          <div className="side-navigation__divider-wrap">
            <Divider variant="fullWidth" />
          </div>
          <PermissionGate requiredPermission="crudContent">
            <>
              <NavLink to="/elements" className={getNavClassName} onClick={handleLinkClick}>
                <Element />{translate("Elements")}</NavLink>
              <NavLink to="/environments" className={getNavClassName} onClick={handleLinkClick}>
                <Environment />{translate("Environments")}</NavLink>
              <NavLink to="/systems" className={getNavClassName} onClick={handleLinkClick}>
                <System />{translate("Systems")}</NavLink>
              <NavLink to="/collections" className={getNavClassName} onClick={handleLinkClick}>
                <Collection />{translate("Collections")}</NavLink>
            </>
          </PermissionGate>
        </div>
        <div className="bottom">
          {canAccessSetupDownloads(roleName) && (
            <NavLink to="/setup" className={getNavClassName} onClick={handleLinkClick}>
              <DownloadRoundedIcon />{translate("VR setup")}</NavLink>
          )}
          <NavLink to="/account" className={getNavClassName} onClick={handleLinkClick}>
            <User />{translate("Account")}</NavLink>
        </div>
      </div>
    </>
  );
};

export default SideNavigation;
